import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { environment } from 'src/environments/environment';
import { AppToastService } from 'src/app/shared/services/app-toast.service';
import { FileUploadService } from '../../services/file-upload.service';
import { getStoredToken } from 'src/app/core/utils/auth-storage';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent implements OnInit,OnChanges {

  uploader: FileUploader;

  baseUrl = environment.apiUrl;
  queueLimit: number = 10;

  @Input() internalApiPath: string;
  @Input() fileType: string = 'image';
  @Input() maxFileSize: number = 100 * 1024 * 1024;
  @Input() allowUploads: boolean = true;
  @Input() extensionType: string[] = null;
  @Output() onSuccess = new EventEmitter();

  @ViewChild('inputFile') inputFile: ElementRef;

  constructor(
    private readonly toastService: AppToastService,
    private fileUploadService: FileUploadService
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.internalApiPath && this.uploader) {
      this.uploader.options.url = this.baseUrl + this.internalApiPath;
    }
  }

  ngOnInit(): void {
    this.initializeUploader();
  }

  initializeUploader() {
    this.uploader = new FileUploader({
      url: this.baseUrl + this.internalApiPath,
      authToken: 'Bearer ' + (getStoredToken() || ''),
      isHTML5: true,
      allowedFileType: [this.fileType],
      removeAfterUpload: true,
      autoUpload: false,
      queueLimit: this.queueLimit,
      maxFileSize: this.maxFileSize,
      allowedMimeType: this.extensionType,
    });

    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      this.uploader.cancelAll();
    };

    this.uploader.onSuccessItem = (item, response, status, headers) => {
      if (response) {
        this.toastService.success('Uploaded', 'File was uploaded successfully.');
        this.fileUploadService.onFileUploadSuccess();
        this.inputFile.nativeElement.value = '';
        this.onSuccess.emit(response);
      }
    };

    this.uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
      this.fileUploadService.onFileUploadError();
    };

    this.uploader.onWhenAddingFileFailed = (item: any, filter: any, options: any) => {
      let message = '';
      switch (filter.name) {
        case 'queueLimit':
          message = 'Maximum number of files allowed: ' + this.queueLimit;
          break;
        case 'fileType':
          message = 'Only the following file type is allowed: ' + this.fileType;
          break;
        case 'fileSize':
          message = 'The file ' + item.name + ' has size of ' + this.formatBytes(item.size)
            + '. The file size limit for uploads is: ' + this.formatBytes(this.maxFileSize);
          break;
        default:
          message = 'Failed to include the file';
          break;
      }
      this.toastService.warning('Validation', message);
    };
  }

  formatBytes(bytes: any, decimals?: number) {
    if (bytes === 0) { return '0 Bytes'; }
    const k = 1024,
      dm = decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  onUpload() {
    this.uploader.uploadAll();
  }
}
